import { request } from './common';

function basePath() {
  return window.configs.API_HOST + '/api/reporting';
}

export function getAiSummaryStats(options?: { signal?: AbortSignal }) {
  return request(`${basePath()}/genesys-call-summary/stats`, {
    method: 'GET',
    ...options,
  });
}
